import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_CURRENCY, PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-blue-950 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-51" data-mp="83w01kxmo269">
      <h2 className="text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-amber-400 md:text-[29px]" data-id="element-52" data-mp="m3ngdsbm9unf">
        Una última pregunta...
      </h2>
      <p className="mx-auto mt-2 max-w-[580px] text-[16px] font-bold leading-[1.35] text-white md:text-[19px]" data-id="element-53" data-mp="vv9q1k8b3lo2">
        ¿Preferís seguir buscando ejercicios y protocolos por separado o tener una colección visual organizada para
        consultarlos?
      </p>
      <p className="mx-auto mt-2 max-w-[580px] text-[14px] leading-[1.45] text-blue-200 md:text-[15px]" data-id="element-54" data-mp="14tdd4kyxwqhz">
        Con ATLAS MIOFASCIAL™ accedés a ejercicios, dosificaciones y herramientas de rehabilitación para seis regiones
        corporales.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-55" data-mp="2h4srqmo8m1wf">
        <ProductImage data-id="element-56" data-mp="2h5ko3zpns3nr" />
      </div>

      <p className="mt-2 text-[15px] font-extrabold uppercase text-white md:text-[17px]" data-id="element-57" data-mp="2m2kuycuc1afx">6 volúmenes + 5 bonos gratis</p>
      <p className="mt-0.5 text-[13px] font-extrabold uppercase text-teal-300 md:text-[14px]" data-id="element-58" data-mp="2r2p1pb5fuqsy">
        440 páginas de recursos clínicos
      </p>
      <p className="mt-3 text-[42px] font-extrabold leading-none tracking-[-1px] text-amber-400 md:text-[50px]" data-id="element-59" data-mp="2v1obb9247bqq">
        {formatPrice(PRODUCT_PRICE)}{' '}
        <span className="text-[18px] tracking-normal text-white md:text-[20px]" data-id="element-60" data-mp="34un2myozxge1">{PRODUCT_CURRENCY}</span>
      </p>
      <div className="mt-3" data-id="element-61" data-mp="39rna9e1hur79">
        <CtaButton mode="checkout" data-id="element-62" data-mp="3eri1jip6lisu">¡Acceder al Atlas completo ahora!</CtaButton>
      </div>
      <p className="mt-2.5 text-[12px] font-semibold text-blue-200 md:text-[13px]" data-id="element-63" data-mp="3epotq02u0sj9">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-64" data-mp="1jo3ijkadab53" />}
        Entrega digital inmediata{guaranteeEnabled && ' · Garantía de 7 días'}
      </p>
    </section>;
}